export const siteSettings = {
  name: "Omega Trade Markets",
  link: "https://omegatrademarkets.net",
  email: "support@omegatrademarkets.net",
  appLink: "https://app.omegatrademarkets.net",
};
